export default {
  props: ['menuItems'],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
  },
  methods: {
    CloseDrawer() {
      this.$store.dispatch('app/SetSidebar', false);
    },
    CloseDrawerOutline(status) {
      !status && this.CloseDrawer();
    },
  },
};
